import { CustomCheckbox, ConfirmModal } from '@/shared/ui/components';
import { gettextReceivedItem } from '@/shared/lib';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { t } from 'ttag';
import { useMarkDeviceReturnedModal } from './useMarkDeviceReturnedModal';
import type { MarkDeviceReturnedModalProps } from './markDeviceReturnedModal.types';
import './markDeviceReturnedModal.scss';

const MarkDeviceReturnedModal = ({
  isOpen,
  toggle,
  data,
  onConfirm: onConfirmProp,
}: MarkDeviceReturnedModalProps) => {
  const { state, onConfirm, onChangeCheckBox, onChangeDate, deviceText } =
    useMarkDeviceReturnedModal({ isOpen, data, onConfirm: onConfirmProp });

  /**
   * Renders one checkbox per received item collected when marking an RMA device as returned. Maps state.receivedItems to CustomCheckbox entries keyed by item name, labels them through gettextReceivedItem, and reports toggles to onChangeCheckBox with the item name and new checked value.
   *
   * @returns The list of received-item checkboxes.
   */
  const renderListCheckBox = () =>
    state.receivedItems.map((value: any, index: any) => (
      <CustomCheckbox
        id={`checkbox-${index}`}
        key={value.name}
        {...({ name: value.name } as any)}
        checked={value.checkBox}
        onChange={(checked) => onChangeCheckBox(value.name, checked)}
        label={gettextReceivedItem(value.name)}
      />
    ));

  return (
    <ConfirmModal
      className="warning-modal mark-device-returned-modal"
      isRedBtn={false}
      isOpen={isOpen}
      title={t`Mark ${deviceText} as returned`}
      customContent={
        <div className="content-modal">
          {state.isSaving && <div className="saving-background" />}
          <div className="title">{t`Received items`}</div>
          <div className="checkbox-list">{renderListCheckBox()}</div>
          {data?.length === 1 && (
            <div className="return-date__body">
              <div className="title">{t`Return date & time`}</div>
              <div className="return-date">
                <DatePicker
                  value={state.returnDate}
                  className="date-time"
                  onChange={onChangeDate}
                  disabledDate={(currentDate) => currentDate.startOf('day') > dayjs()}
                  showTime={{ format: 'HH:mm' }}
                  format="MM/DD/YYYY HH:mm"
                  needConfirm
                  disabled={state.isSaving}
                />
              </div>
            </div>
          )}
        </div>
      }
      isBoldLeftBtn
      leftButtonName={t`Cancel`}
      onClickLeftButton={() => toggle()}
      rightButtonName={t`Mark as returned`}
      isFilledRightButton
      onClickRightButton={onConfirm}
      isSaving={state.isSaving}
    />
  );
};

export default MarkDeviceReturnedModal;
